export default "__VITE_ASSET__szDZ8bGe__ 758w, __VITE_ASSET__kK6qvmrG__ 500w";